var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8336 11.2902L10.5936 7.05019C10.5006 6.95646 10.39 6.88207 10.2682 6.8313C10.1463 6.78053 10.0156 6.75439 9.88361 6.75439C9.75159 6.75439 9.62089 6.78053 9.49903 6.8313C9.37717 6.88207 9.26657 6.95646 9.1736 7.05019C8.98735 7.23756 8.88281 7.49101 8.88281 7.75519C8.88281 8.01938 8.98735 8.27283 9.1736 8.46019L12.7136 12.0002L9.1736 15.5402C8.98735 15.7276 8.88281 15.981 8.88281 16.2452C8.88281 16.5094 8.98735 16.7628 9.1736 16.9502C9.26705 17.0429 9.37786 17.1162 9.4997 17.166C9.62154 17.2157 9.752 17.241 9.88361 17.2402C10.0152 17.241 10.1457 17.2157 10.2675 17.166C10.3893 17.1162 10.5002 17.0429 10.5936 16.9502L14.8336 12.7102C14.9273 12.6172 15.0017 12.5066 15.0525 12.3848C15.1033 12.2629 15.1294 12.1322 15.1294 12.0002C15.1294 11.8682 15.1033 11.7375 15.0525 11.6156C15.0017 11.4938 14.9273 11.3832 14.8336 11.2902Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArrowRight);
export default __webpack_public_path__ + "static/media/menu-arrow-right.43121be1107e8eec358f5eac4aeccfa5.svg";
export { ForwardRef as ReactComponent };